module.exports = __webpack_public_path__ + "assets/media/TravelPolesApart_video.ac1125f6-ps.mp4";